import { render, staticRenderFns } from "./myTeaFriends.vue?vue&type=template&id=f623e658&scoped=true&"
import script from "./myTeaFriends.vue?vue&type=script&lang=js&"
export * from "./myTeaFriends.vue?vue&type=script&lang=js&"
import style0 from "./myTeaFriends.vue?vue&type=style&index=0&id=f623e658&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f623e658",
  null
  
)

export default component.exports